import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./state/store";
import { BrowserRouter } from "react-router-dom";
import TagManager from "react-gtm-module";
//import ReactPixel from "react-facebook-pixel";
import { setUrlAssoluto } from "./utils/axiosBase";
import BASENAME from "./utils/basename";
import BASESTORAGE from "./utils/basestorage";
import URLASSOLUTO from "./utils/urlassoluto";

import App from "./App";

// Grab the state from a global variable injected into the server-generated HTML
const { initialData } = window.__PRELOADED_STATE__;

//console.log("sono qui", initialData);

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__;

const store = configureStore(initialData[0]);

// setto già le variabili globali per percorsi assoluti e relativi
setUrlAssoluto(initialData);
BASESTORAGE(initialData);
URLASSOLUTO(initialData);

// lingua corrente
const suffissoLang = initialData[0]["currentPage"]["currentLang"].replace(
  "_",
  ""
);
// inizializzazione google tag manager
/*const gtmSuffix = `gtm_code_${suffissoLang}`;
const gtmAuthSuffix = `gtm_auth_${suffissoLang}`;
const gtmPreviewSuffix = `gtm_preview_${suffissoLang}`;
const currentGTMTAG = initialData[0]["siteParams"][gtmSuffix];
const currentGTMAUTH = initialData[0]["siteParams"][gtmAuthSuffix];
const currentGTMPREVIEW = initialData[0]["siteParams"][gtmPreviewSuffix];

console.log("inizializzo tagManagerxx");
if (currentGTMTAG !== null) {
  const tagManagerArgs = {
    gtmId: currentGTMTAG,
    auth: currentGTMAUTH,
    preview: currentGTMPREVIEW,
    dataLayer: {
      page_type: pageName,
      userId: "ribola",
      userProject: "sito2021",
    },
  };
  if (typeof window !== "undefined") {
    console.log("inizializzo tagManager");
    TagManager.initialize(tagManagerArgs);
  }
}
*/
const fbqSuffix = `pixelfacebook_${suffissoLang}`;
const currentFBQTAG = initialData[0]["siteParams"][fbqSuffix];
if (currentFBQTAG !== null) {
  const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false, // enable logs
    disablePushState: true, //not recommended, but can be done.
  };

  if (typeof window !== "undefined") {
    //console.log("inizializzo Pixel Facebook");
    //ReactPixel.init(currentFBQTAG, null, options);
    //ReactPixel.pageView();
  }
}

// DOM element
if (document.getElementById("app")) {
  ReactDOM.hydrate(
    <Provider store={store}>
      <BrowserRouter basename={BASENAME(initialData)}>
        <App />
      </BrowserRouter>
    </Provider>,
    document.getElementById("app")
  );
}
